import { setSnackbar } from "../../snackbar";

export default () => async (dispatch) => {
  dispatch(
    setSnackbar({
      open: true,
      message: "Success! Collection URL copied to clipboard",
      severity: "default",
    })
  );
};
